export default "__VITE_ASSET__CvylmmRr__"